module.exports = __webpack_public_path__ + "img/des-2.1f0456d1.jpg";